import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { NavBarComponent } from './nav-bar.component';
import { NvIconModule } from '../../nvps-libraries/design/nv-icon/nv-icon.module';
import { NvIconButtonModule } from '../../nvps-libraries/design/nv-icon-button/nv-icon-button.module';
import { SharedSidebarListResponsiveModule } from './shared-sidebar-list-responsive/shared-sidebar-list-responsive.module';
import { NvLogoModule } from '../../nvps-libraries/design/nv-logo/nv-logo.module';
import { NvAriaLabelModule } from '../../nvps-libraries/design/directives/nv-aria-label/nv-aria-label.module';
import { NvDropdownBoxModule } from '../../nvps-libraries/design/nv-dropdown-box/nv-dropdown-box.module';

@NgModule({
  declarations: [NavBarComponent],
  imports: [
    CommonModule,
    NvAriaLabelModule,
    NvDropdownBoxModule,
    NvIconButtonModule,
    NvIconModule,
    NvLogoModule,
    SharedSidebarListResponsiveModule,
  ],
  exports: [NavBarComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class NavBarModule {}
